export const projectsStats = {
   total: 12,
   inProgress: 5,
   completed: 7
}

export const currentProjects = [
   {
      id: 1,
      name: "Website Redesign",
      category: "Design",
      completion: 75,
      weeks: 3,
      daysLeft: 12,
      teamMember: [3, 1, 5],
      priority: 1,
   },
   {
      id: 2,
      name: "Mobile App Development",
      category: "Development",
      completion: 45,
      weeks: 8,
      daysLeft: 24,
      teamMember: [4, 2],
      priority: 2,
   },
   {
      id: 3,
      name: "Marketing Campaign",
      category: "Marketing",
      completion: 90,
      weeks: 14,
      daysLeft: 5,
      teamMember: [3, 2, 5, 1],
      priority: 3,
   },
]

export const taskBar_tasks = [
   {
      id: 1,
      taskName: "Design Review",
      teamMember: 1,
      day: "Mon",
      style_data: {
         width: "130px",
         bg_color: "blue"
      }
   }, {
      id: 2,
      taskName: "Client Meeting",
      teamMember: 1,
      day: "Wed",
      style_data: {
         width: "180px",
         bg_color: "pink"
      }
   }, {
      id: 3,
      taskName: "API Integration",
      teamMember: 2,
      day: "Tue",
      style_data: {
         width: "150px",
         bg_color: "green"
      }
   },
   {
      id: 4,
      taskName: "Frontend Development",
      teamMember: 2,
      day: "Thu",
      style_data: {
         width: "220px",
         bg_color: "blue"
      }
   }, {
      id: 5,
      taskName: "Content Creation",
      teamMember: 3,
      day: "Fri",
      style_data: {
         width: "200px",
         bg_color: "pink"
      }
   }, {
      id: 6,
      taskName: "Bug Fixing",
      teamMember: 3,
      day: "Mon",
      style_data: {
         width: "180px",
         bg_color: "green"
      }
   }, {
      id: 7,
      taskName: "Testing",
      teamMember: 3,
      day: "Wed",
      style_data: {
         width: "150px",
         bg_color: "blue"
      }
   }, {
      id: 8,
      taskName: "Deployment",
      teamMember: 4,
      day: "Tue",
      style_data: {
         width: "250px",
         bg_color: "pink",
      }
   }
]